export default __webpack_public_path__ + "static/media/8.937e4b0a.jpg";